<div class="edit-modal-overlay" (click)="close()">
  <div class="edit-modal" (click)="$event.stopPropagation()">
    <h5>ფაილის რედაქტირება</h5>

    <input
      type="text"
      [(ngModel)]="newName"
      class="form-control"
    />

    <div class="mt-3 d-flex gap-2 justify-content-end">
      <button class="btn btn-primary" (click)="rename()">შენახვა</button>
      <button class="btn btn-secondary" (click)="close()">დახურვა</button>
    </div>
  </div>
</div>